
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
    showFixtures: {
      type: Boolean,
      default: true,
    },
    showTable: {
      type: Boolean,
      default: true,
    },
  },
  data () {
    return {
      tabs: [],
      activeTab: null,
    };
  },
  computed: {
    showTabs () {
      return this.showFixtures && this.showTable;
    },
    numFixtures () {
      return this.siteSettings.fixture_list_fixtures;
    },
    numResults () {
      return this.siteSettings.fixture_list_results;
    },
    fixturesTitle () {
      return this.siteSettings.sidebar_fixtures_title;
    },
    tableTitle () {
      return this.siteSettings.sidebar_league_table_title;
    },
    activeComponent () {
      return this.isActive(`fixtures`) ? `fixtures` : `table`;
    },
  },
  mounted () {
    this.tabs = [this.fixturesTitle, this.tableTitle];
    this.activeTab = this.tabs[0];
  },
  methods: {
    isActive (tab) {
      if (tab === `fixtures`) {
        return this.showTabs
          ? this.activeTab === this.fixturesTitle
          : this.showFixtures;
      } else if (tab === `table`) {
        return this.showTabs
          ? this.activeTab === this.tableTitle
          : this.showTable;
      }
    },
  },
};
